// extracted by mini-css-extract-plugin
export default {"head":"Content-Head__head--IGQyb"};